export default "__VITE_ASSET__Bl89X35h__"